import gql from 'graphql-tag';

export default gql`
  query lastCompletedBookingStep {
    application(name: DESKTOPBOOKINGPATH) {
      ... on DesktopBookingPath {
        lastBookingStepCompleted
      }
    }
  }
`;
